/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:27:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 19:05:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/common.ts
 */
import { generateCollapse } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
export enum EnumCollapseId {
  contentSetting = 'saleChannelContent404ContentSetting',
  buttonText = 'saleChannelContent404ButtonText',
}

export const fixedCollapse = [
  EnumCollapseId.buttonText,
  EnumCollapseId.contentSetting,
];

export const defaultCollapse = (display?) => {
  return generateCollapse(fixedCollapse, display);
};

export const generateDefaultFeaturedProducts = () => {
  return {
    text: '返回首页',
  };
};

export const generateDefaultButtonText = () => {
  return {
    text: '返回首页',
  };
};

export const generateDefaultContentSetting = () => {
  return {
    text: '非常抱歉，您访问的页面不存在',
    image: {
      altText: 'products',
      contentType: 'image/svg+xml',
      createdBy: 'admin',
      createdDate: '2021-04-27 10:00:00',
      deleted: false,
      fileName: 'unifyxp2/default/page404/404.svg',
      height: 81,
      modifiedBy: 'admin',
      modifiedDate: '2021-04-27 10:00:00',
      originalName: '404.svg',
      size: 1708,
      tags: [],
      url: 'https://resource2.unifyxp.com/unifyxp2/default/page404/404.svg',
      uuid: 'c0d7da8c-2b41-4e58-b5de-ecbd261c501c',
      valid: true,
      width: 81,
    },
  };
};
